import { primaryAddress } from "@productlane/lib/src/email-settings"
import { Badge, Button } from "@productlane/ui"

import type { EmailInboxSettingsProps } from "../types"
import { toast } from "@/components/toast"
import { api } from "@/lib/api"

export function EnableEmailStep({ workspace }: EmailInboxSettingsProps) {
	const utils = api.useUtils()
	const updateMutation = api.mail.updateEmailIntegration.useMutation({
		onSuccess: async () => {
			await utils.workspace.info.invalidate()
		},
	})
	return (
		<>
			<div className="mb-2 flex justify-between">
				<div className="font-semibold text-primary">Enable emails</div>
				{primaryAddress(workspace.emailSettings)?.isEnabled && (
					<Badge variant="green">Active</Badge>
				)}
			</div>
			<div className="mb-6 text-sm text-secondary">
				You&apos;re all set. Last step is to enable emails for your workspace.
			</div>
			<div className="mt-4 flex justify-end">
				<Button
					isLoading={updateMutation.isLoading}
					onClick={async () => {
						const result = await updateMutation.mutateAsync({ isEnabled: true })
						if (result.isEnabled) {
							toast.success({
								title: "Emails enabled",
								description:
									"You can now send and receive emails with Productlane.",
							})
						}
					}}
				>
					Enable emails
				</Button>
			</div>
		</>
	)
}
